import { Spin } from "antd";
import React from "react";
import apiClient from "../../../api/axiosConfig.tsx";
import { LoadingOutlined } from "@ant-design/icons";
import { format, parseISO } from "date-fns";

const CheckUserScanQR = () => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [listIndex, setListIndex] = React.useState<any>([]);
  const [result, setResult] = React.useState<any>(undefined);

  const handleCreateAccount = async () => {
    setLoading(true);
    const res = await apiClient.get(`/upload/check-qr`, {
      params: {
        rootLink: listIndex,
      },
    });
    console.log("res?.data ===== ", res?.data);
    if (res?.data?.status) {
      setLoading(false);
      setResult(res?.data?.data);
    } else {
      setLoading(false);
      setResult([]);
      // alert(res?.data?.message || "Kiểm tra coupon thất bại");
    }
  };

  const classInput =
    "w-full border-[1px] border-[pink] rounded-md px-2 py-2 outline-none";
  const classLable =
    "md:font-semibold text-[pink] max-md:text-[10px] max-md:mb-3";

  return (
    <div className="w-full">
      <div className="text-2xl text-center text-[pink] font-bold">
        KIỂM TRA NGƯỜI QUÉT MÃ
      </div>
      <div className="mb-3">
        <div className={classLable}>Nhập đường dẫn mã QR đã quét</div>
        <input
          onChange={(value) => {
            setListIndex(value.target.value);
          }}
          type="text"
          className={classInput}
        />
      </div>

      <div className="flex justify-center">
        <button
          className="mb-4 bg-[pink] text-white py-3 px-6 rounded-md"
          onClick={() => {
            handleCreateAccount();
          }}
        >
          {loading ? (
            <Spin
              className="text-white"
              indicator={<LoadingOutlined color="white" spin />}
              size="small"
            />
          ) : (
            "Kiểm tra"
          )}
        </button>
      </div>
      {!!result && (
        <div className="flex flex-col gap-2">
          <div className={classLable}>Thông tin người quét mã</div>
          <div className="flex flex-col gap-4">
            <div className="flex gap-6 w-fit">
              <div className="flex flex-col gap-1">
                <span className="text-sm">Tên người dùng:</span>
                <div className="flex items-center py-[2px] pl-[4px] pr-[20px] border-[1px] rounded-md w-fit">
                  <span className="text-sm text-gray-500">
                    {result?.user?.name ? result?.user?.name : "Chưa cập nhập"}
                  </span>
                </div>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-sm">Email:</span>
                <div className="flex items-center py-[2px] pl-[4px] pr-[20px] border-[1px] rounded-md w-fit">
                  <span className="text-sm text-gray-500">
                    {result?.user?.email
                      ? result?.user?.email
                      : "Chưa cập nhập"}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex gap-4 w-fit">
              <div className="flex flex-col gap-1">
                <span className="text-sm">Số điện thoại:</span>
                <div className="flex items-center py-[2px] pl-[4px] pr-[20px] border-[1px] rounded-md w-fit">
                  <span className="text-sm text-gray-500">
                    {result?.user?.phoneNumber
                      ? result?.user?.phoneNumber
                      : "---"}
                  </span>
                </div>
              </div>
              {result?.story?.createdAt && (
                <div className="flex flex-col gap-1">
                  <span className="text-sm">Ngày quét:</span>
                  <div className="flex items-center py-[2px] pl-[4px] pr-[20px] border-[1px] rounded-md w-fit">
                    <span className="text-sm text-gray-500">
                      {format(parseISO(result?.story?.createdAt), "dd/MM/yyyy")}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckUserScanQR;
